import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class FinishTimingRecordModel extends Model 
{
	@attr('date') entryTime;
	@attr('boolean',{defaultValue: true}) participatesInAutoAssociation;
	@attr('boolean',{defaultValue: false}) hasDupFinish;
	@attr('boolean',{defaultValue: false}) isPosted;
	
	@belongsTo('timing-impulse', {inverse: null, async: true}) finishImpulseId;
	@belongsTo('timing-impulse', {inverse: null, async: true}) finishPlungerImpulseId;

	@belongsTo('event', {inverse: 'finishTimingRecords', async: true}) EventId;
	@belongsTo('entry', {inverse: 'FinishTimingRecordId', async: true}) EntryId;
}